<div class="component-container">
    <table-panel header="Cechy" class="flex flex-grow" newOneTitle="Nowa cecha" (createNewOne)="create()">
        <pr-new-table
            panel-body
            class="flex flex-grow"
            [dataService]="featuresDataService"
            [columnsData]="columnsData"
            [tableId]="tableId"
            [navigationArr]="navigateLinkArr"
            [canNavigate]="canNavigate"
        >
        </pr-new-table>
    </table-panel>
</div>
